export const QUOTES_ADMIN_CONSTANTS = Object.freeze({
    LIST: 'QUOTES_ADMIN__LIST',
    STATUS_UPDATE: 'QUOTES_ADMIN__STATUS_UPDATE',
});

const C = QUOTES_ADMIN_CONSTANTS;

export const QUOTES_ADMIN_ENDPOINTS = Object.freeze({
    [C.LIST]: '/portfolio/quotes/admin',
    [C.STATUS_UPDATE]: '/portfolio/quotes/admin/status',
});

export const QUOTES_ADMIN_API = Object.freeze({
    LIST: C.LIST,
    STATUS_UPDATE: C.STATUS_UPDATE,
});
